<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-tool-bar" style="justify-content: space-between">
        <div class="common-page common-head-title">
          <i class="icon-tr--detailed" style="padding-right: 5px"></i>
          查岗记录
        </div>
      </div>
    </div>
    <div style="text-align: end;">
      <el-button v-hasPermi="['monitor:check:recordexport']" @click="open()" size="small" type="primary" plain>导出文件</el-button>
      <div class="btn" v-hasPermi="['monitor:check:recordquery']" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>
    </div>
    <div class="flex">
      <div class="flex1">
        <el-tabs style=" width: 100vw" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="设备查岗" name="device">
            <div>
              <div class="common-page common-list">
                <el-table :data="list" class="">
                  <el-table-column prop="c_type" align="center" label="单位类型">
                    <template slot-scope="scope">
                      {{ $map.unitType[scope.row.c_type] }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="c_name" label="单位名称" align="center"> </el-table-column>

                  <el-table-column prop="device_code" label="设备编号" align="center"> </el-table-column>
                  <el-table-column prop="c_address" align="center" label="地址"> </el-table-column>
                  <el-table-column prop="user_name" align="center" label="查岗人员"> </el-table-column>
                  <el-table-column prop="c_phone" align="center" label="联系电话"> </el-table-column>
                  <el-table-column prop="sendtime" align="center" label="查岗时间"> </el-table-column>

                  <el-table-column prop="backtime" align="center" label="应答时间"> </el-table-column>
                  <el-table-column prop="states" align="center" label="结果">
                    <template slot-scope="scope">
                      {{ $map.checkStatus[scope.row.states] }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-pagination background style="margin-right: 65px" layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"> </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="摄像头查岗" name="camera">
            <div>
              <div class="common-page common-list">
                <el-table :data="cameraList" class="" :cell-style="cellStyle">
                  <el-table-column
                    prop="deviceNum"
                    align="center"
                    label="设备号"
                  >
                    <!-- <template slot-scope="scope">
                      {{ $map.unitType[scope.row.c_type] }}
                    </template> -->
                  </el-table-column>
                  <el-table-column prop="companyName" label="单位名称" align="center"> </el-table-column>

                  <el-table-column prop="cameraAddress" label="摄像头地址" align="center"> </el-table-column>
                  <!-- <el-table-column prop="c_address" align="center" label="地址">
                  </el-table-column> -->
                  <el-table-column prop="leaveTime" align="center" label="离岗时间"> </el-table-column>

                  <el-table-column
                    style="color:red"
                    prop="leaveDurationStr"
                    align="center"
                    label="离岗时长"
                  >
                  </el-table-column>
                  <el-table-column
                  prop="state"
                    align="center"
                    label="状态"
                  >
                  <template slot-scope="scope">
                      {{ scope.row.state?'在岗':'离岗'}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="phone" align="center" label="联系电话">
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" v-hasPermi="['cameraLeave:cameraLeaveInfo:query']" @click="lookDetail(scope.$index, scope.row)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-pagination style="margin-right: 65px" background layout="prev, pager, next" @current-change="pageChangeCamera" :page-size="10" :total="cameraTotal">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="canclesub" size="small">重置</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请选择公司" :visible.sync="daomodle" :close-on-click-modal="false">
      <el-form ref="form" label-width="110px">
        <el-form-item label="单位名称:">
          <el-select v-model="outform.c_company_num" filterable style="width: 100%">
            <el-option v-for="item in shangjioption" :key="item.value" :label="item.key" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间:" prop="" style="width: 100%" class="flex1">
          <el-date-picker v-model="outform.starttime" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd 00:00:00"> </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:" style="width: 100%" class="flex1">
          <el-date-picker v-model="outform.endtime" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd 23:59:59"> </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="center">
        <el-button type="primary" @click="output" size="small">导出</el-button>
        <el-button @click="cancleout" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogCameraVisible">
      <div class="cameraTotal">
        <div class="cameraLeft">
          <h3 class="cameraLeft_firestTime">首次离岗画面</h3>
          <div class="cameraLeft_leave">
            离岗时间：<span>{{ cameraDilogDetail.leaveTime }}</span>
          </div>

          <img style="width: 300px; height: 300px; cursor: pointer" @click="cameraBig" :src="cameraDilogDetail.leaveCameraImage" alt="" />
          <div class="cameraLeft_leaveTime">
            离岗时长：<span class="cameraLeft_leaveTime_s">{{ cameraDilogDetail.leaveDuration }}</span>
          </div>
        </div>
        <div class="cameraRight" style="width: 50%">
          <h3 class="cameraLeft_firestTime">报警详情</h3>
          <div>
            选择时间：
            <el-time-picker
              style="width: 20vw"
              @change="timerClick"
              is-range
              v-model="timeValue1"
              value-format="HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            >
            </el-time-picker>
          </div>
          <el-table :data="cameraDilogList" style="width: 100%">
            <el-table-column prop="remark" label="报警顺序" sortable width="180"> </el-table-column>
            <el-table-column prop="alarmTime" label="报警时间" width="180"> </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next,sizes"
            @current-change="pageChangeDilogCamera"
            @size-change="handleSizeChange"
            :page-sizes="[1, 5, 10]"
            :page-size="dilogPageSize"
            :pager-count="5"
            :current-page="cameraDilogPgeNum"
            :total="cameraDilogTotal"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getrecord } from '../../api/device';
import { getMapByid } from '../../api/common';
export default {
  data() {
    return {
      cameraUrl: '@/assets/img/bim_img/IndoorFireHydrant.png',
      timeValue1: '',
      activeName: 'device',
      list: [],
      cameraList: [],
      cameraDilogList: [],
      cameraDilogDetail: [],
      dialogCameraVisible: false,
      params: {
        page: 1,
        aftertime: '',
        beforetime: '',
        c_name: '',
      },
      cameraParams: {
        pageNum: 1,
        aftertime: '',
        beforetime: '',
        c_name: '',
      },
      cameraDilogPgeNum: 1,
      total: 0,
      cameraTotal: 0,
      cameraDilogTotal: 0,
      daomodle: false,
      shangjioption: [],
      outform: {
        c_company_num: '',
        starttime: '',
        endtime: '',
      },
      showDia: false,
      searchForm: this.$getForm('checkRecordSearch'),
      editData: {},
      remoteFuncs: {},
      dilogRow: '',
      dilogPageSize: 5,
      dilogStartTime: '',
      dilogEndTime: '',
      tabIndex: 0,
      topAscOrbottomDesc: 'asc',
      itemKey: 0,
    };
  },
  created() {
    this.getList();
  },
  components: {},
  methods: {
    topArrowClick() {
      this.topAscOrbottomDesc = 'asc';
      this.itemKey = 0;
      this.dilogListData();
    },
    bottomArrowClick() {
      this.topAscOrbottomDesc = 'desc';
      this.itemKey = 1;
      this.dilogListData();
    },
    cameraBig() {
      console.log(this.cameraDilogDetail.leaveCameraImage);
      // window.open(this.cameraDilogDetail.leaveCameraImage,_blank)
      window.open('', '').document.write(`<img src='${this.cameraDilogDetail.leaveCameraImage}' style='width:70%;height:80%'/>`);
      // window.open(this.cameraDilogDetail.leaveCameraImage)
    },
    timerClick() {
      console.log(this.timeValue1, 22222);
      if (this.timeValue1) {
        this.dilogStartTime = this.timeValue1[0];
        this.dilogEndTime = this.timeValue1[1];
        this.pageChangeDilogCamera(1);
        return;
      } else {
        this.dilogStartTime = '';
        this.dilogEndTime = '';
      }

      this.dilogListData();
    },
    handleSizeChange(val) {
      console.log(val, 111111);
      this.dilogPageSize = val;
      this.dilogListData();
    },
    lookDetail(index, row) {
      // console.log(index, row);
      this.dialogCameraVisible = true;
      this.dilogRow = row.id;
      this.dilogListData();
    },
    dilogListData() {
      this.$get(
        '/webcamLeave/webcamLeaveInfo/getInfo?id=' +
          this.dilogRow +
          '&&pageNum=' +
          this.cameraDilogPgeNum +
          '&&pageSize=' +
          this.dilogPageSize +
          '&&startTime=' +
          this.dilogStartTime +
          '&&endTime=' +
          this.dilogEndTime +
          '&&orderByColumn=alarm_time' +
          '&&isAsc=' +
          this.topAscOrbottomDesc,
      ).then((res) => {
        // console.log(res,22222);
        this.cameraDilogTotal = res.data.cameraLeaveAlarmList.total;
        this.cameraDilogList = res.data.cameraLeaveAlarmList.rows;
        this.cameraDilogDetail = res.data;
      });
    },
    handleClick(tab, event) {
      this.tabIndex = tab.index;
      this.outform = {
        c_company_num: '',
        starttime: '',
        endtime: '',
      };
      if (tab.index == 1) {
        this.getCameraList();
      }
    },
    // changeStatus(id,status){
    //     switchCompany({id,status}).then(res=>{
    //         this.getList()
    //     }).catch(err=>{

    //     })
    // },
    cancleout() {
      this.outform.c_company_num = '';
      this.daomodle = false;
    },
    //导出
    output() {
      if (!this.outform.c_company_num) {
        this.$message.warning('请选择导出单位');
        return;
      }
      if (!this.outform.starttime || !this.outform.endtime) {
        this.$message.warning('请选择导出日期');
        return;
      }
      if (this.tabIndex == 0) {
        var url = `${this.$config.apiUrl}/queryjob/queryjobdownload?c_company_num=${this.outform.c_company_num}&starttime=${this.outform.starttime}&endtime=${this.outform.endtime}`;
        window.open(url, '_blank');
      } else {
        // var url = `${this.$config.apiUrl}/webcamLeave/webcamLeaveInfo/export?c_company_num=${this.outform.c_company_num}&starttime=${this.outform.starttime}&endtime=${this.outform.endtime}`;
        this.$post('/webcamLeave/webcamLeaveInfo/export', this.outform).then((res) => {
          console.log(res);
          this.download(res.msg);
        });
      }

      // this.$get('/queryjob/queryjobdownload',this.outform).then(res=>{
      //   console.log(res)
      // })
    },
    open() {
      (this.daomodle = true),
        this.$post('/devicemanage/selectconpanybyme').then((res) => {
          var arr = [];
          res.data.map((item) => {
            var obj = { key: item.c_name, value: item.c_company_num };
            arr.push(obj);
          });
          this.shangjioption = arr;
        });
    },
    canclesub() {
      this.showDia = false;
      if (this.tabIndex == 0) {
        this.params = {
          page: 1,
          aftertime: '',
          beforetime: '',
          c_name: '',
        };
        this.getList();
      } else {
        this.cameraParams = {
          pageNum: 1,
          aftertime: '',
          beforetime: '',
          c_name: '',
        };
        this.getCameraList();
      }
    },
    getList() {
      getrecord(this.params)
        .then((res) => {
          // console.log(res.data)
          this.total = res.data.count;
          this.list = res.data.list;

          // console.log(this.list)
        })
        .catch((err) => {});
    },
    getCameraList() {
      this.$post("/webcamLeave/webcamLeaveInfo/list", this.cameraParams).then(
        (res) => {
          let array = res.rows.map((element) => {
            element.leaveDurationStr = element.leaveDurationStr + '"';
            // console.log(element.leaveDurationStr);
            return element;
          });
          this.cameraTotal = res.total;
          // console.log(array,11111111111);
          this.cameraList = array;
        }
      );
    },
    cellStyle({row, column, rowIndex, columnIndex}){
        	if(column.property === 'state'){
          	switch(row.state) {
            	case 0:
              	return {
                  color: 'red'
                }
              	break
              case 1:
              	return {
                  color: 'grey'
                }
              	break
            }
          }
          if(column.property ==='leaveDurationStr'){
          	switch(row.state) {
            	case 0:
              	return {
                  color: 'red'
                }
              	break
              case 1:
              	return {
                  color: 'grey'
                }
              	break
            }
          }
        },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    pageChangeCamera(val) {
      this.cameraParams.pageNum = val;
      this.getCameraList();
    },
    pageChangeDilogCamera(val) {
      console.log(val, 222);
      this.cameraDilogPgeNum = val;
      this.dilogListData();
    },
    searchSubmit() {
      if (this.tabIndex == 0) {
        this.$refs.searchForm
          .getData()
          .then((data) => {
            log(data, 1111);
            // var data = {...data,beforetime:data.startdate+' '+data.starttime,aftertime:data.enddate+' '+data.endtime}
            // console.log(data)
            this.params = { ...this.params, ...data };
            this.params.page = 1;

            // console.log(data)
            this.getList();

            this.showDia = false;
          })
          .catch((e) => {});
      } else {
        this.$refs.searchForm.getData().then((data) => {
          // log(data,2222) cameraParams
          this.cameraParams = { ...this.cameraParams, ...data };
          this.cameraParams.pageNum = 1;
          this.getCameraList();
          this.showDia = false;
        });
      }
    },
    getUnit() {},
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
.btn {
  margin-left: 10px;
}
::v-deep .el-tabs__nav-wrap {
  width: 277px;
}
::v-deep .el-tabs__nav-scroll {
  margin-left: 30px;
}
::v-deep .el-tabs__nav-wrap::after {
  width: 203px;
  margin-left: 30px;
}
::v-deep .el-dialog {
  width: 60%;
}
::v-deep .el-tabs__item {
  /* padding: 0 30px; */
}
::v-deep .el-tabs__item.is-top:nth-child(2) {
  /* padding-left: 30px; */
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 1vw;
}

.cameraTotal {
  display: flex;
  justify-content: space-around;
}
.cameraRight {
  border-left: 1px solid rgb(138, 138, 138);
  padding-left: 30px;
}
.cameraLeft_firestTime {
  width: 100%;
  text-align: center;
  margin-bottom: 15px;
}
.cameraLeft_leave {
  font-size: 16px;
  margin-bottom: 15px;
}
.cameraLeft_leaveTime {
  font-size: 16px;
  margin-top: 15px;
}
.cameraLeft_leaveTime_s {
  padding: 5px 10px;
  border: 1px solid rgb(139, 139, 139);
  border-radius: 5px;
  color: red;
}
.arrow {
  /* position: relative; */
  width: 100%;
  display: flex;
}
.topArrow {
  z-index: 100;
  width: 0;
  height: 0;
  border: 6px solid rgb(255, 255, 255);
  /* border-bottom-color: rgb(120, 154, 247); */
  /* margin-left: 3%; */
  margin-left: 5px;
  /* border-color: #fff #fff rgb(168, 168, 168) #fff; */
  /* position: absolute; */
  /* left: 3vw; */
  /* top: 0vh; */
  cursor: pointer;
}
.bottomArrow {
  z-index: 100;
  width: 0;
  height: 0;
  border: 6px solid #fff;
  /* border-top-color: rgb(168, 168, 168); */
  margin: 15px 0 0 -12px;
  /* margin: 7% 0 0 -5.3%; */
  /* border-color: rgb(168, 168, 168) #fff #fff #fff; */
  /* position: absolute; */
  /* left: 3vw; */
  /* top: 1.5vh; */
  cursor: pointer;
}
</style>
